import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      useErrorBoundary: true
    }
  }
});
const ReactQueryProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, children);
};
export default ReactQueryProvider;